@if (showFilters) {
  <div class="filter-container" blazeClickable="BUTTON">
    <blaze-complex-filter
      #complexFilterComponent
      [query]="query"
      [useAppTheme]="true"
      [isInOrganizeMode]="isInOrganizeMode"
      [layout]="layout"
      (queryChange)="onQueryChange($event)"
      (lastRowDeleted)="apply()"
    >
      <div
        complex-filters-buttons
        class="flex gap-16 align-center justify-end"
        [class.column-layout]="layout === 'column'"
      >
        <button
          [class.hidden]="!showSavedFiltersButton"
          type="button"
          class="filter-actions"
          cdkOverlayOrigin
          [disabled]="isSavedFiltersDisabled"
          #savedFiltersTrigger="cdkOverlayOrigin"
          (click)="toggleSavedFiltersDialog()"
        >
          Saved filters
        </button>
        <ng-template
          cdkConnectedOverlay
          [cdkConnectedOverlayOrigin]="savedFiltersTrigger"
          [cdkConnectedOverlayOpen]="savedFiltersDialogIsOpen"
          [cdkConnectedOverlayHasBackdrop]="true"
          cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
          (backdropClick)="savedFiltersDialogIsOpen = false"
        >
          <blaze-saved-filters
            [filters]="filters"
            [disableSave]="!hasValidNodes"
            [showLoadingIndicator]="showLoadingForSavedFilters"
            [allowToCreatePublicFilters]="allowToCreatePublicFilters"
            (apply)="applySavedFilter($event)"
            (save)="save($event)"
            (delete)="deleteFilter.emit($event)"
          />
        </ng-template>
        <button
          type="button"
          data-cy="FilterBuilder:ApplyBtn"
          class="filter-actions primary"
          [disabled]="isApplyDisabled || complexFilterComponent?.busy"
          (click)="apply()"
        >
          Apply
        </button>
      </div>
    </blaze-complex-filter>
  </div>
}
